import { getLanguageCode } from '@utils/languageCodes';

interface LanguageOption {
  value: string;
  label: string;
}

export const LANGUAGES: LanguageOption[] = [
  { value: 'American English', label: 'US English' },
  { value: 'British English', label: 'UK English' },
  { value: 'Modern Standard Arabic', label: 'Arabic' },
  { value: 'Bahasa Indonesia', label: 'Bahasa Indonesia' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Brazilian Portuguese', label: 'Brazilian Portuguese' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Danish', label: 'Danish' },
  { value: 'Dutch', label: 'Dutch' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Greek', label: 'Greek' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Korean', label: 'Korean' },
  { value: 'Moldavan', label: 'Moldavan' },
  { value: 'Polish', label: 'Polish' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Turkish', label: 'Turkish' },
  { value: 'Urdu', label: 'Urdu' },
  { value: 'Vietnamesian', label: 'Vietnamesian' },
];

export const getLanguageOptions = (): LanguageOption[] =>
  LANGUAGES.map((lang) => ({ value: lang.value, label: lang.label }));

const BASE_LANGUAGE_BY_VALUE: Record<string, string> = {
  'American English': 'English',
  'British English': 'English',
  'Modern Standard Arabic': 'Arabic',
  'Brazilian Portuguese': 'Portuguese',
};

export const baseLanguageName = (value: string): string => BASE_LANGUAGE_BY_VALUE[value] ?? value;

export const languageLabel = (value: string): string =>
  LANGUAGES.find((lang) => lang.value === value)?.label ?? value;

export const languageValueForBase = (base: string): string =>
  LANGUAGES.find((lang) => lang.value === base)?.value
  ?? LANGUAGES.find((lang) => baseLanguageName(lang.value) === base)?.value
  ?? base;

const REGIONAL_BADGE_CODES: Record<string, string> = {
  'British English': 'GB',
  'Brazilian Portuguese': 'BR',
};

export const languageBadgeCode = (value: string): string =>
  REGIONAL_BADGE_CODES[value] ?? getLanguageCode(value).toUpperCase();
